/** Max messages sent to the chat API (saga also enforces this). */
export const CHAT_API_CONTEXT_LIMIT = 19;

/** Build { content, role }[] for sendMsgCompanions — slice before Redux dispatch. */
export function buildChatApiHistory(chatHistory, limit = CHAT_API_CONTEXT_LIMIT) {
  if (!Array.isArray(chatHistory) || !chatHistory.length) {
    return [];
  }
  return chatHistory
    .filter((item) => item.type !== "date")
    .slice(-limit)
    .map((item) => ({ content: item.text, role: item.type }));
}
